import {HttpErrorResponse} from '@angular/common/http';

export interface NormalizedHttpError {
  status: number;
  message: string;
  details?: unknown;
}

// Convert a raw HttpErrorResponse to a compact, UI‑friendly structure.
// This keeps error handling uniform across the app and decouples
// component code from backend error shapes.
export function normalizeHttpError(err: HttpErrorResponse): NormalizedHttpError {
  const status = err.status ?? 0;
  const message = (err.error && (err.error.message || err.error.error)) || err.statusText || 'Unknown error';
  const details = err.error?.details ?? err.error ?? undefined;
  return { status, message, details };
}


